"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortBy = sortBy;
exports.filterByExactly = filterByExactly;
exports.filterByContaining = filterByContaining;
exports.useControllableTable = useControllableTable;

var _react = require("react");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function defaultSortByFn(a, b) {
  // force null and undefined to the bottom
  a = a === null || a === undefined ? '' : a;
  b = b === null || b === undefined ? '' : b; // force any string values to lowercase

  a = typeof a === 'string' ? a.toLowerCase() : a;
  b = typeof b === 'string' ? b.toLowerCase() : b; // Return either 1 or -1 to indicate a sort priority

  if (a > b) {
    return 1;
  }

  if (a < b) {
    return -1;
  } // returning 0, undefined or any falsey value will defer to the next
  // sorting mechanism or eventually the columns index via the orderByFn


  return 0;
}

function sortBy(predicate) {
  return function (a, b, desc) {
    return defaultSortByFn(predicate(a), predicate(b), desc);
  };
}

function filterByExactly() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function (row, columnName, filterValue) {
    return [].concat(args).map(function (pred) {
      // Empty string matches all
      if (filterValue === '') return true;
      var value = pred(row.values[columnName]);
      return !!value && String(value).toLowerCase() === String(filterValue).toLowerCase();
    }).filter(function (x) {
      return x;
    }).length;
  };
}

function filterByContaining() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return function (row, columnName, filterValue) {
    return [].concat(args).map(function (pred) {
      // Empty string matches all
      if (filterValue === '') return true;
      var value = pred(row.values[columnName]);
      return !!value && String(value).toLowerCase().includes(String(filterValue).toLowerCase());
    }).filter(function (x) {
      return x;
    }).length;
  };
}

function useControllableTable(defaultControls, defaultData, onControlsChangeCallback) {
  var data = _objectSpread({
    rows: [],
    pageCount: 0,
    totalRecordCount: 0
  }, defaultData); // eslint-disable-next-line no-shadow


  var _useState = (0, _react.useState)(_objectSpread({
    sortBy: [],
    filters: {},
    pageIndex: 0,
    pageSize: 10
  }, defaultControls)),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      sortBy = _useState2$.sortBy,
      filters = _useState2$.filters,
      pageIndex = _useState2$.pageIndex,
      pageSize = _useState2$.pageSize,
      setControls = _useState2[1];

  (0, _react.useEffect)(function () {
    onControlsChangeCallback({
      sortBy: sortBy,
      filters: filters,
      pageIndex: pageIndex,
      pageSize: pageSize
    });
  }, [sortBy, filters, pageIndex, pageSize, onControlsChangeCallback]);
  return {
    defaultSortBy: sortBy,
    defaultFilters: filters,
    defaultPageIndex: pageIndex,
    pageSize: pageSize,
    data: data.rows,
    pageCount: data.pageCount,
    totalRecordCount: data.totalRecordCount,
    onControlsChange: setControls,
    serverPagination: true,
    disablePageResetOnDataChange: true
  };
}